var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 filters-field" }, [
          _c("span", [_vm._v("Filters:")]),
          _vm._v(" "),
          _vm.filtersLoaded
            ? _c("span", [
                _vm.filters.created_at
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("created_at")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Created At: " +
                          _vm._s(_vm.filters.created_at)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.payment_method_id
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("payment_method_id")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Payment Method: " +
                          _vm._s(
                            _vm.paymentMethods.find(function(el) {
                              return el.id === _vm.filters.payment_method_id
                            }).name
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.payment_type_id
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("payment_type_id")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Payment Type: " +
                          _vm._s(
                            _vm.paymentTypes.find(function(el) {
                              return el.id === _vm.filters.payment_type_id
                            }).name
                          )
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary add-filters",
              on: {
                click: function($event) {
                  _vm.showFilters = true
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus filter-icon" })]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.transactions
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover" }, [
              _c("thead", { staticClass: "m-table__heading" }, [
                _c("tr", [
                  _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "created_at" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("created_at")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Date\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["created_at"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "payment_method_id" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("payment_method_id")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Method\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["payment_method_id"]
                          ? "dsc"
                          : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "payment_type_id" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("payment_type_id")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Type\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["payment_type_id"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Ref ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "amount" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("amount")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Amount\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["amount"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Notes")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.transactions, function(transaction, index) {
                    return _c(
                      "tr",
                      {
                        key: "trans-prefix-" + index,
                        class: { pointer: _vm.$_can("job-charges.show") },
                        on: {
                          mouseup: function($event) {
                            _vm.$_can("job-charges.show") &&
                              _vm.view($event, transaction.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(transaction.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(transaction.date))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(transaction.payment_method.name))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(transaction.payment_type.name))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(transaction.ref_id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v("$ " + _vm._s(transaction.total))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "position-relative" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link p-0 tippy-popup",
                              class: !transaction.note && "text-secondary",
                              on: {
                                mouseover: function($event) {
                                  _vm.showNote(index)
                                },
                                mouseout: function($event) {
                                  _vm.hideNote(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-sticky-note" })]
                          ),
                          _vm._v(" "),
                          _vm.note[index] && transaction.note
                            ? _c("div", { staticClass: "popover" }, [
                                _c("p", [_vm._v(_vm._s(transaction.note))])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.transactions && !_vm.transactions.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "8" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "filters-side-modal flex flex-column" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.showFilters = !_vm.showFilters
                          }
                        }
                      },
                      [
                        _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                          _c("span", { staticClass: "btn btn-back" }),
                          _vm._v("Add Filter")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "l-bg-white" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "row filters" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "select-wrap select-wrap-calendar"
                                },
                                [
                                  _c("label", [_vm._v("Created At")]),
                                  _vm._v(" "),
                                  _c("flat-pickr", {
                                    staticClass: "simple-select-input",
                                    attrs: {
                                      config: _vm.config,
                                      placeholder: "Select Created Date",
                                      name: "date"
                                    },
                                    on: { "on-close": _vm.onCreatedDateChange },
                                    model: {
                                      value: _vm.filters.created_at,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "created_at", $$v)
                                      },
                                      expression: "filters.created_at"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.filters.created_at
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date",
                                          on: {
                                            click: _vm.clearCreatedDateAndSearch
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-clear"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sr-only",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [_vm._v("Clear")]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date clear-date-transparent"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-rates-dark"
                                          })
                                        ]
                                      )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Payment method")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.paymentMethods,
                                      placeholder: "Select Payment Method"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.payment_method_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "payment_method_id",
                                          $$v
                                        )
                                      },
                                      expression: "filters.payment_method_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Payment type")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.paymentTypes,
                                      placeholder: "Select Payment Type"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.payment_type_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "payment_type_id",
                                          $$v
                                        )
                                      },
                                      expression: "filters.payment_type_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-auto" }, [
                      _c("div", { staticClass: "col" }, [
                        !(
                          !_vm.filters.created_at &&
                          !_vm.filters.payment_type_id &&
                          !_vm.filters.payment_method_id
                        )
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-not-active text-dark w-100",
                                attrs: { type: "button" },
                                on: { click: _vm.clearFilters }
                              },
                              [
                                _vm._v(
                                  "\n              Clear filters\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
      _c("div", { staticClass: "col-12" }, [_c("h1", [_vm._v("Transactions")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7380408f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7380408f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transactions/Transactions.vue
// module id = null
// module chunks = 